import eng from './trans/eng.json'
import rus from './trans/rus.json'
import itl from './trans/itl.json'

import { initReactI18next } from 'react-i18next'
import i18n from 'i18next'


const resources = {
    eng: {
        translation: eng,
    },
    rus: {
        translation: rus,
    },
    itl: {
        translation: itl,
    }
}

i18n
    .use(initReactI18next)
    .init({
        resources,
        lng: JSON.parse(localStorage.getItem('language')),
        fallbackLng: 'rus'
    })

export default i18n;